/**
 * JardinsOleHomePage — Modern Mowix-inspired homepage assembly.
 * Reads dynamic content from settings/services/products/realizations APIs.
 * Sets data-jdo-home="yes" on body to hide cockpit's default home sections via CSS.
 */
import React, { useEffect } from "react";
import JOHero from "@/components/jardins-ole/sections/JOHero";
import JOMarquee from "@/components/jardins-ole/sections/JOMarquee";
import JOPresentation from "@/components/jardins-ole/sections/JOPresentation";
import JOMetiers from "@/components/jardins-ole/sections/JOMetiers";
import JOEngagements from "@/components/jardins-ole/sections/JOEngagements";
import JOStory from "@/components/jardins-ole/sections/JOStory";
import JOProducts from "@/components/jardins-ole/sections/JOProducts";
import JORealizations from "@/components/jardins-ole/sections/JORealizations";
import JOProClickCollect from "@/components/jardins-ole/sections/JOProClickCollect";
import JODestockageBanner from "@/components/jardins-ole/sections/JODestockageBanner";
import JOServicesSpotlight from "@/components/jardins-ole/sections/JOServicesSpotlight";
import JOTestimonials from "@/components/jardins-ole/sections/JOTestimonials";
import JOZones from "@/components/jardins-ole/sections/JOZones";
import JOCta from "@/components/jardins-ole/sections/JOCta";
import { useSettings } from "@/lib/useSettings";

export default function JardinsOleHomePage() {
  const { settings: s } = useSettings();

  useEffect(() => {
    document.body.setAttribute("data-jdo-home", "yes");
    return () => { document.body.removeAttribute("data-jdo-home"); };
  }, []);

  return (
    <>
      <title>{s ? `${s.company_name} — ${s.company_baseline || s.tagline}` : "Les Jardins d'Éole"}</title>
      <meta name="description" content={s?.footer_description || s?.hero_subtitle || ""} />
      <JOHero />
      <JOMarquee />
      <JOServicesSpotlight />
      <JOPresentation />
      <JOMetiers />
      <JOEngagements />
      <JOStory />
      <JOProducts />
      <JODestockageBanner />
      <JORealizations />
      <JOProClickCollect />
      <JOTestimonials />
      <JOZones />
      <JOCta />
    </>
  );
}
